module.exports = __webpack_public_path__ + "img/hire_vehicles.a6e7db77.jpeg";